import React, { useEffect, useState } from "react";
import { useFormContext, useFieldArray } from "react-hook-form";
import { useTabContext } from "../context/context";
import AvailabilityRow from "./AvailabilityRow";
import AvailabilityHeader from "./AvailabilityHeader";
import { useServiceIDLookup } from "../data/AvailTools";

const AvailabilityTable = () => {
  const { availabilityList, changesMade, saving, allowedServices, errorMessage, setErrorMessage, warningMessage, setWarningMessage } = useTabContext();
  const serviceIDLookup = useServiceIDLookup(allowedServices);

  const {
    control,
    setValue,
    formState: { errors }
  } = useFormContext();

  const { fields, append, remove } = useFieldArray({
    name: "availability",
    control
  });

  const today = new Date();
  const todayPST = new Date(today.getTime() - today.getTimezoneOffset() * 60000);

  useEffect(() => {
    if (availabilityList) {
      // Clear existing fields
      remove();
      availabilityList.forEach(availability => {
        const serviceLookup = serviceIDLookup[availability.service];
        const term_id = serviceLookup ? serviceLookup.term_id : "";
        append({
          quantity: availability.number || 0,
          term_id: term_id || "",
          room_care: availability.room || "",
          service: availability.service || "",
          gender: availability.gender || "",
          reimbursement: availability.insurance || [],
          date_available: availability.available || ""
        });
      });
    }
  }, [availabilityList, append, remove, serviceIDLookup]);

  return (
    <div className="provider-section">
      <h3>Add/Update Availability</h3>
      <h4>
        <span className="font-semibold">Notice:</span> Please select a quantity of at least 1. If you have "0" in the quantity field, it will not show in the search results or your listing page.
      </h4>
      <div className="mt-4">
        {changesMade && !errorMessage && (
          <div className="text-red-500">
            Changes have been made to your availability. Please save your changes.
            <button type="submit" className="ca-v3-admin-btn" disabled={saving || Boolean(errorMessage)}>
              {saving ? "Saving..." : "Save"}
            </button>
          </div>
        )}
        <AvailabilityHeader />
        {fields.map((item, index) => (
          <AvailabilityRow key={item.id} item={item} index={index} control={control} setValue={setValue} remove={remove} setErrorMessage={setErrorMessage} saving={saving} setWarningMessage={setWarningMessage} />
        ))}
        {errorMessage && (
          <div className="text-red-500 border border-red-500 bg-red-100 my-2 p-2 rounded-sm">
            <span className="font-semibold">Error:</span> {errorMessage}
          </div>
        )}

        {warningMessage && (
          <div className="text-yellow-500 border border-yellow-500 bg-yellow-100 my-2 p-2 rounded-sm">
            <span className="font-semibold">Warning:</span> {warningMessage}
          </div>
        )}
        <button
          type="button"
          className="ca-v3-admin-btn"
          onClick={() =>
            append({
              id: new Date().getTime(),
              unit_id: `unit_${fields.length + 1}`,
              quantity: 0,
              term_id: "",
              name: "",
              room_care: "",
              date_available: todayPST,
              gender: "",
              service: "",
              reimbursement: []
            })
          }
        >
          + Add New
        </button>
      </div>
    </div>
  );
};

export default AvailabilityTable;
